import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const ChangesItem = styled.li`
  padding: 10px 0 20px;
  border-bottom: 1px solid ${COLORS.black};

  &:last-child {
    border-bottom: none;
  }
`;

export default ChangesItem;
